import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/api";

export const chargily_payment = createAsyncThunk(
  "payment/chargily_payment",
  async (paymentData, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.post(
        "/payment/chargily-payment",
        paymentData,
        {
          withCredentials: true,
        }
      );
      return fulfillWithValue(data.url);
    } catch (error) {
      console.log("Axios Error:", error.response?.status, error.response?.data);
      return rejectWithValue(error.response?.data?.error || "Payment failed");
    }
  }
);

export const create_subscription = createAsyncThunk(
  "payment/create_subscription",
  async (subscriptionData, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.post(
        "/payment/create-subscription",
        subscriptionData,
        {
          withCredentials: true,
        }
      );
      return fulfillWithValue(data.subscription);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const get_subscription = createAsyncThunk(
  "payment/get_subscription",
  async (userId, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.get(`/payment/get-subscription/${userId}`, {
        withCredentials: true,
      });
      return fulfillWithValue(data);
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const PaymentReducer = createSlice({
  name: "payment",
  initialState: {
    successMessage: "",
    errorMessage: "",
    loader: false,
    url: null,
    subscriptions: [],
  },
  reducers: {
    messageClear: (state, _) => {
      state.errorMessage = "";
      state.successMessage = "";
    },
  },
  extraReducers: {
    [chargily_payment.pending]: (state) => {
      state.loader = true;
      state.error = null;
    },

    [chargily_payment.fulfilled]: (state, { payload }) => {
      state.loader = false;
      state.url = payload;
    },

    [chargily_payment.rejected]: (state, { payload }) => {
      state.loader = false;
      state.errorMessage = payload;
    },
    [create_subscription.pending]: (state) => {
      state.loader = true;
      state.error = null;
    },

    [create_subscription.fulfilled]: (state, { payload }) => {
      state.loader = false;
      state.subscriptions = payload.subscriptions;
      state.successMessage = payload.message;
    },

    [create_subscription.rejected]: (state, { payload }) => {
      state.loader = false;
      state.errorMessage = payload.message;
    },

    [get_subscription.fulfilled]: (state, { payload }) => {
      state.subscriptions = payload.subscriptions;
    },
  },
});
export const { messageClear } = PaymentReducer.actions;
export default PaymentReducer.reducer;
